export const RECEIVE_CONFIG = 'RECEIVE_CONFIG'
export const SET_INSTALL_PM_APP_URL = 'SET_INSTALL_PM_APP_URL'
export const REQUEST_SUCCESS = 'REQUEST_SUCCESS'
export const REQUEST_ERROR = 'REQUEST_ERROR'
